import { Auth } from "./Auth";
import { AuthType } from "./AuthType";
import { AuthBase } from "./AuthBase";
import { AuthJWT } from "./AuthJWT";

export class AuthSimpleFactory {
  public static create(authType: AuthType): Auth {
    switch (authType) {
      case AuthType.Base:
        return new AuthBase();
      case AuthType.JWT:
        return new AuthJWT();
      default:
        return new AuthJWT();
    }
  }
}
